import React from "react"
import { Map, TileLayer, Marker } from 'react-leaflet'
import './leafletmap.scss'
import pin from '../images/icon/marker.svg'

  export const DispayLeafletMap = props => {
    const L = require('leaflet');
    const myIcon = L.icon({
      iconUrl: pin,
      iconSize: [90, 90],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    });
  
  return (
    <Map 
      className="mt-4 hauteurMapProducteur"
      center={props.center} 
      zoom={props.zoom}
      minZoom={5}
      zoomDelta={0.1}
    >
      <TileLayer
        url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a>"
      />
      {props.markers.map(({ key, ...group }) => (
        <Marker 
          icon={myIcon}
          key={group.key}  position={group.position}>
        </Marker>
      ))}
    </Map>
  );
  
}

export default DispayLeafletMap
